import { useEffect, useState, useRef } from 'react';
import { useSession } from './SessionProvider';
import DeadlineField from "../components/DeadlineField";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import { parseISO, format } from 'date-fns';
import DatePicker from "../components/ui/DatePicker";
import { useApi } from "../hooks/useApi";

const ProcessingStatus = () => {
    const [error, setError] = useState(null);

    const { status, setStatus, showStatus, setShowStatus, statusTrigger, log_minimized, setLog_minimized } = useSession();
    const [published, setPublished] = useState(false);
    const [processed, setProcessed] = useState(false);
    const [deadline, setDeadline] = useState('');
    const [minDate, setMinDate] = useState(null);
    const [open, setOpen] = useState(false);
    const baseName = import.meta.env.VITE_APP_BASE_URL;
    const divRef = useRef(null);
    const statusRef = useRef(null);
    const { apiCall } = useApi();
    useEffect(() => {
        const twoWeeksFromNow = new Date();
        twoWeeksFromNow.setDate(twoWeeksFromNow.getDate() + 1);

        const minDateTemp = twoWeeksFromNow.toISOString().slice(0, 10);
        setMinDate(minDateTemp);
        setDeadline(minDateTemp);

        let timer;
        let cancelled = false;

        const fetchStatus = async () => {
            let processed = false;

            try {
                const response = await apiCall('getProcessingStatus');

                if (!response.ok) {
                    console.error(
                        'Status API failed:',
                        response.status,
                        await response.text()
                    );
                    return;
                }

                const data = await response.json();

                if (cancelled) return;

                if (data.message && data.message !== statusRef.current) {
                    statusRef.current = data.message;
                    setStatus(data.message);
                }

                if (data.message) {
                    setError(null);
                    setShowStatus(true);
                } else {
                    setShowStatus(false);
                }

                if (data.processed == 1) {
                    setProcessed(data.processed);
                    processed = true;
                }
            } catch (err) {
                console.error('Status polling error:', err);
            } finally {
                if (!cancelled && !processed) {
                    timer = setTimeout(fetchStatus, 5000);
                }
            }
        };

        fetchStatus();

        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [statusTrigger]);

    // Scroll to bottom whenever the div is expanded
    useEffect(() => {
        if (log_minimized) {
            // Small timeout ensures the transition has started 
            // so the scroll target is in a valid position
            if (!divRef.current) return;

            divRef.current.scrollTop = divRef.current.scrollHeight;
        }
    }, [status]);

    const publishCodingSheet = async () => {
        try {
            const response = await apiCall('publishCodingSheet', { params: { deadline: deadline } });
            const data = await response.json();

            if (data?.success === true) {
                setPublished(true);
                if (data?.message) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    setStatus(data.message + ' .. reloading');
                }
                setOpen(false);
                setTimeout(() => {
                    window.location.href = window.location.origin + baseName;
                }, 5000); // redirect to the main page after 5seconds
            }
            else {
                setError(data?.error || 'Something went wrong during publishing');
            }


        } catch (err) {
            setError('Error publishing');
        }
    };
    const handleDeadlineChange = (selectedDate) => {
        // Send partial update to backend
        const deadline = selectedDate;
        setDeadline(deadline);

    };
    const mini_style = { background: '#dae4ef', maxHeight: '130px', overflow: 'auto' };
    const default_style = { background: '#dae4ef' };
    return (
        <div>

            {showStatus && (
                <div className="relative">
                    {status && status.length > 100 && (
                        <button
                            onClick={() => setLog_minimized(!log_minimized)}
                            className="text-xs z-1 cursor-pointer bg-amber-600 text-amber-50 p-2 absolute top-2 right-7 hover:bg-amber-500 rounded-full transition-colors"
                        >
                            {!log_minimized ? 'Minimize' : 'Maximize'}
                        </button>
                    )}



                    <div ref={divRef} style={log_minimized ? mini_style : default_style} className='text-center p-2 text-sm relative'>

                        {error ? (
                            <span style={{ color: 'red' }}>{error}</span>
                        ) : (
                            <div dangerouslySetInnerHTML={{ __html: status }} />
                        )}
                        {processed == 1 && !published ? (
                            <>
                                <div className="pt-2 border-t-2 mt-4 w-full text-gray-700 font-medium mb-2 text-center flex flex-col items-center gap-2">
                                    <h3 className="font-bold text-2xl">Set a Deadline</h3>
                                    <p className="text-orange-400">Remember to change the default deadline</p>
                                    <DatePicker value={deadline} minDate={minDate} changeFunction={handleDeadlineChange} />
                                </div>
                                <button
                                    className="my-4 btn btn-primary"
                                    onClick={() => setOpen(true)}
                                >
                                    Publish Coding Sheet
                                </button>
                                <ConfirmDialog
                                    open={open}
                                    title="Confirmation"
                                    message={'Are you sure you want to publish this coding sheet? <br><br>The deadline is: <strong>' + format(parseISO(deadline), 'M/d/yyyy') + '</strong>'}
                                    confirmText="Publish"
                                    cancelText="Cancel"
                                    onConfirm={publishCodingSheet}
                                    onCancel={() => setOpen(false)}
                                />

                            </>
                        ) : null}
                    </div>
                </div>
            )}

            <div>

                {/* {published ? (
                    <div style={{ background: '#dae4ef' }} className='text-center p-2 text-sm relative'>
                        <div>Successfully published</div>

                    </div>

                ) : null} */}
            </div>
        </div>
    );
};

export default ProcessingStatus;
